<template>
    <div>
        <AppSelect :value="fromYear"
                   :options="years"
                   field="contact_user"
                   track-by="year"
                   label-field="year"
                   :disabled="loading"
                   placeholder="Select from year"
                   class="mr-2"
                   @input="$emit('on-from-input', $event)"/>
        <AppSelect :value="toYear"
                   :options="years"
                   field="contact_user"
                   track-by="year"
                   :disabled="loading"
                   label-field="year"
                   placeholder="Select to year"
                   class="mr-2"
                   @input="$emit('on-to-input', $event)"/>
        <AppSelect :value="dateType"
                   :options="dateTypes"
                   track-by="value"
                   :disabled="loading"
                   label-field="value"
                   placeholder="Select range type"
                   class="mr-2"
                   @input="$emit('on-date-type-input', $event)"/>
    </div>
</template>
<script>
import AppSelect from '../form/AppSelect';

export default {
  components: {
    AppSelect,
  },
  props: ['fromYear', 'toYear', 'dateType', 'fillFromYear', 'loading'],
  data() {
    return {
      years: [],
      dateTypes: [
        { name: 'Months', value: 'months' },
        { name: 'Years', value: 'years' },
      ],
    };
  },
  mounted() {
    const fromYear = Number(this.fillFromYear);
    const toYear = new Date().getFullYear();
    for (let i = fromYear; i <= toYear; i++) {
      this.years.push({ year: i });
    }
  },
  methods: {
  },
};
</script>
